<template>
  <div class="sorts">
    <div class="btns" style="padding-right: 20px; line-height: 38px">
      <a-button type="primary" @click="toCreate">创建论文集</a-button>
    </div>

    <sort
      :sortType="sortType"
      :chagneSortType="chagneSortType"
      :list="sortList"
    />
  </div>
  <div class="split-line"></div>
  <div class="collection-list">
    <div class="col-item" v-for="item in list" :key="item.id">
      <div class="title">
        <router-link
          :to="{ path: '/collection_detail', query: { id: item.id } }"
          target="_blank"
          >{{ item.name }}</router-link
        >
      </div>
      <router-link
        :to="{ path: '/collection_detail', query: { id: item.id } }"
        target="_blank"
      >
        <div class="desc" v-if="item.summary">{{ item.summary }}</div>
      </router-link>
      <div class="keyword" v-if="item.topicsName">
        <!-- <a-tag v-for="i in item.topicsName" :key="i">
                    {{i}}
                </a-tag> -->
        <a-tag v-for="i in item.topicList" :key="i.topicId">
          <!-- <router-link
                    :to="{ path: '/view/topic', query: { id: i.topicId } }"
                    target="_blank"
                  > -->
          {{ i.topicName }}
          <!-- </router-link> -->
        </a-tag>
        <div class="clearx"></div>
      </div>
      <div class="user" v-if="item.userInfoEntity">
        <div class="count" style="color: #666">
          {{ item.collectQua ? numWan(item.collectQua) : 0 }}人收藏
          <a-divider type="vertical" /> {{ numWan(item.articleQua) }}篇论文
        </div>
        <div class="pic">
          <router-link
            :to="{ path: '/user/articles', query: { id: item.userId } }"
          >
            <img
              v-if="item.userInfoEntity.imgUrl"
              :src="imgSiteUrl + item.userInfoEntity.imgUrl"
              alt=""
            />
            <img v-else src="~@/assets/img/head1.png" />
          </router-link>
        </div>
        <div class="username" :title="item.userInfoEntity.userName">
          <router-link
            :to="{ path: '/user/articles', query: { id: item.userId } }"
          >
            {{ item.userInfoEntity.userName }}
          </router-link>
        </div>
        <div class="date">· {{ getDate(item) }}</div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
  <div class="page">
    <a-pagination
      :current="currentPage"
      :pageSize="10"
      show-quick-jumper
      :total="total"
      @change="changePage"
      :hideOnSinglePage="true"
    />
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  computed,
  watchEffect,
} from "vue";
import config from "../../until/configs";
import Http from "../../until/http";
import { useRoute, useRouter } from "vue-router";
import { numWan ,getCookie,confirmLogin} from "@/until/tools";
import Sort from "../../components/Sort.vue";

export default defineComponent({
  components: { Sort },

  setup() {
    const state = reactive({
      list: [],
      total: 0,
      imgSiteUrl: config.imgSiteUrl,
      sortList: [
        { value: 0, title: "最近更新" },
        { value: 1, title: "浏览最多" },
      ],
    });

    const route = useRoute();
    const router = useRouter();
    const currentPage = computed(() => {
      let page = route.query.page;
      if (page) {
        return parseInt(page);
      }
      return 1;
    });
    const sortType = computed(() => {
      let type = route.query.sort;
      if (type) {
        return parseInt(type);
      }
      return 0;
    });

    const changePage = (page) => {
      router.push({
        path: "/essay_collection",
        query: { page: page, sort: sortType.value },
      });
    };

    watchEffect(() => {
      Http.getEssayCollections({
        pageNum: currentPage.value,
        sortType: sortType.value,
      }).then((res) => {
        if (res) {
          Object.assign(state, {
            list: res.aggItems,
            total: res.condition.totalColumns,
          });
          window.scrollTo(0, 0);
        }
      });
    });

    const getList = (params) => {
      Http.getEssayCollections(params).then((res) => {
        if (res) {
          if (res.aggItems) {
            Object.assign(state, {
              list: res.aggItems,
              total: res.condition.totalColumns,
            });
          }
        }
      });
    };

    const getDate = (item) => {
      if (item.addTime === item.lstModTime) {
        return item.addTime.substring(0, 10) + "创建";
      } else {
        return item.lstModTime.substring(0, 10) + "更新";
      }
    };
 const sid = computed(() => {
      return getCookie("z_sid") || null;
    });
    const toCreate = () => {
      if (!sid.value) {
        confirmLogin();
      } else {
        router.push({ path: "/essay_create_collection" });
      }
    };

    const chagneSortType = (e) => {
      router.push({ path: "/essay_collection", query: { sort: e } });
    };

    onMounted(() => {
      let page = route.query.page||1;
      getList({ sortType: 0, pageNum: page });
    });

    return {
      ...toRefs(state),
      getList,
      getDate,
      changePage,
      toCreate,
      currentPage,
      sortType,
      chagneSortType,
      numWan,
      sid
    };
  },
});
</script>

<style lang="scss" scoped>
.ant-tag {
  background: #fff;
}
</style>